<div class="product-ad-inventory-analysis-modal">
  <div class="modal-header">
    <h4 class="modal-title">Ad Control Analysis for {{ sku }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="layout-grid">
      <!-- Section 1: Inventory Available -->
      <div class="section section-inventory">
        <h6 class="section-title">1. INVENTORY AVAILABLE</h6>
        <div class="inventory-table-container">
          <table class="table table-striped inventory-table">
            <thead>
              <tr>
                <th class="table-th-custom">Inventory Source</th>
                <th class="text-right table-th-custom">Units</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let row of inventoryRows; let last = last">
              <tr *ngIf="!row.hidden" [class.total-row]="row.isTotalRow">
                <td>
                  <span>{{ row.label }}</span>
                  <i
                    *ngIf="row.info"
                    class="feather icon-info ml-1 text-muted"
                    [ngbTooltip]="row.info"
                    placement="right"
                    tooltipClass="tooltip-high-zindex"
                  ></i>
                </td>
                <td class="text-right inventory-table__row-data" [class.fw-bold]="last">{{ row.value }}</td>
              </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Section 2: Logic Applied -->
      <div class="section section-logic">
        <h6 class="section-title">2. LOGIC APPLIED</h6>
        
        <div class="logic-metrics params-grid">
          <div class="param-box">
            <span class="param-val">🔥 {{ productAd.saleVelocity }}</span>
            <span class="param-key">UNITS/DAY</span>
          </div>
          <div class="param-box">
            <span class="param-val">📦 {{ productAd.inventoryAvailable }}</span>
            <span class="param-key">INVENTORY</span>
          </div>
        </div>

        <div class="formula-box">
          <ng-container *ngIf="true">
            <app-asc-day-until-stock-out-formula
              [inventory]="productAd.inventoryAvailable"
              [velocity]="productAd.saleVelocity"
              [daysUntilStockOut]="productAd.daysUntilStockOut"
            ></app-asc-day-until-stock-out-formula>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Section 3: Inventory Health -->
    <div class="section section-health">
      <h6 class="section-title">3. INVENTORY HEALTH</h6>
      <div class="health-card">
        <div class="health-card-header">
          <span class="days-text"><strong>{{ productAd.daysUntilStockOut }}</strong> days until stockout</span>
          <div class="status-chip" [ngClass]="healthChipClass">
            <span class="status-dot"></span>
            {{ healthStatusText }}
          </div>
        </div>
        <app-product-ad-inventory-health
          [daysUntilStockOut]="productAd.daysUntilStockOut"
          [minThreshold]="productAd.minDaysStockout || company?.minDaysUntilStockOutRisk || 7"
          [maxThreshold]="productAd.maxDaysStockout || company?.maxDaysUntilStockOutRisk || 30"
        ></app-product-ad-inventory-health>
      </div>
    </div>

    <!-- Section 4: Recommendation -->
    <div class="section section-recommendation">
      <h6 class="section-title">4. RECOMMENDATION</h6>
      <div class="recommendation-alert" [ngClass]="recommendation.alertClass">
        <div class="recommendation-icon-box">
          <i class="feather" [ngClass]="recommendation.icon"></i>
        </div>
        <div class="alert-content">
          <div class="alert-title">{{ recommendation.title }}</div>
          <div class="alert-message">{{ recommendation.message }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      *ngIf="recommendation.action === AdRecommendAction.NONE"
      type="button"
      class="btn btn-cancel"
      (click)="onCancel()"
    >Close</button>

    <ng-container *ngIf="recommendation.action !== AdRecommendAction.NONE">
      <button type="button" class="btn btn-cancel" (click)="onCancel()">Cancel</button>
      <button
        [disabled]="!isManagedBySystem()"
        *ngIf="recommendation.action === AdRecommendAction.PAUSE"
        type="button"
        class="btn btn-danger btn-action"
        (click)="onAction()"
      >
        <i class="feather icon-pause mr-2"></i>
        Pause SKU
      </button>
      <button
        [disabled]="!isManagedBySystem()"
        *ngIf="recommendation.action === AdRecommendAction.ENABLE"
        type="button"
        class="btn btn-success btn-action"
        (click)="onAction()"
      >
        <i class="feather icon-play mr-2"></i>
        Enable SKU
      </button>
    </ng-container>
  </div>
</div>
